import { createApiCall } from 'lib/base';

const POST_INVESTCORE_EMPLOYEE_PROGRAM_PENDING_API_ID =
  'DASHBOARD/POST_INVESTCORE_EMPLOYEE_PROGRAM_PENDING_API_ID';

const apiCall = createApiCall(
  POST_INVESTCORE_EMPLOYEE_PROGRAM_PENDING_API_ID,
  ({ id }) => ({
    endpoint: `/api/admin/employee-programs/${id}/pending`,
    method: 'POST',
    isStay: true,
    notify: true,
  })
);

export default apiCall;
